import { takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import * as sitesActions from './actions';
import { apiSagaV2 } from '../../../helpers/saga';
import { AdminApi } from 'src/api';

const getSitesSaga = apiSagaV2(sitesActions.getSites, async (connection, action) => {
  const { page, searchText } = action.payload;

  return new AdminApi(connection).getSites(page, searchText);
});

const editSiteSaga = apiSagaV2(sitesActions.editSite, async (connection, action) => {
  const { id, data } = action.payload;

  return new AdminApi(connection).editSite(id, data);
});

export function* sitesSagas() {
  yield takeEvery(getType(sitesActions.getSites.request), getSitesSaga);
  yield takeEvery(getType(sitesActions.editSite.request), editSiteSaga);
}
